/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OutputAllMenuPagesPermissionDto } from '../../models/output-all-menu-pages-permission-dto';

export interface UserManagementGetMenusPagesPermissionByRoleIdGet$Plain$Params {
  roleId?: number;
  env?: string;
}

export function userManagementGetMenusPagesPermissionByRoleIdGet$Plain(http: HttpClient, rootUrl: string, params?: UserManagementGetMenusPagesPermissionByRoleIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>> {
  const rb = new RequestBuilder(rootUrl, userManagementGetMenusPagesPermissionByRoleIdGet$Plain.PATH, 'get');
  if (params) {
    rb.query('roleId', params.roleId, {});
    rb.query('env', params.env, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>;
    })
  );
}

userManagementGetMenusPagesPermissionByRoleIdGet$Plain.PATH = '/UserManagement/GetMenusPagesPermissionByRoleId';
